export const FEATURE_FLAGS = {
  RELEASE_PARTNER_INTERVIEW_ROUND_SETTINGS: "release-partner-interview-stage-settings",
  RELEASE_JOB_INTERVIEW_PLAN: "release-job-interview-plan",
  KILL_SWITCH_USE_INTERVIEW_ROUND_TYPES_ENDPOINT: "kill-switch-use-interview-round-types-endpoint",
  RELEASE_TIPTAP_EDITOR: "release-tiptap-editor",
  RELEASE_PARTICIPANT_JOB_DETAIL: "release-participant-job-detail",
  RELEASE_PREVIEW_JOB_DETAIL: "release-preview-job-detail",
  RELEASE_PARTNERS_VIEW_UPDATE: "release-partners-view-update",
  RELEASE_PARTNER_MUTATION_UPDATE: "release-partner-mutation-update",
  RELEASE_ASSIGNMENT_UPDATE: "release-assignment-update",
  RELEASE_MEMBER_SETUP_FLOW: "member-setup-flow",
  RELEASE_NEW_LOGIN: "release-new-login",
} as const;

export type PostHogFeatureFlag = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];
